import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { SafeAreaView } from 'react-native';
import { AppRegistry } from 'react-native';
import BuildType from './BuildType';
import { createBrowserHistory } from 'history';
import { store as newStore , persistor } from './src/store/newstore';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

const history = createBrowserHistory();
// 1. Set up the browser history with the updated location
// (minus the # sign)
const path = location.href.includes('#!')
  ? (/#!(\/.*)$/.exec(location.hash) || [])[1]
  : location.pathname;
if (path) {
  // history.replace(path);
  history.replace({
    pathname: path,
    search: location.search,
  });
}

const ReduXWrapper = () => {
  return (
    <SafeAreaProvider>
      <Provider store={newStore}>
        <PersistGate loading={null} persistor={persistor}>
          <BuildType />
        </PersistGate>
      </Provider>
    </SafeAreaProvider>
  );
};
AppRegistry.registerComponent('Volt', () => ReduXWrapper);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<ReduXWrapper />);
